// @flow
import { ContactsActionTypes } from './constants';

type ContactsAction = { type: string, payload: {} | string };

// common success
export const contactsApiResponseSuccess = (actionType: string, data: any): ContactsAction => ({
    type: ContactsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const contactsApiResponseError = (actionType: string, error: string): ContactsAction => ({
    type: ContactsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getContact = (id: string): ContactsAction => ({
    type: ContactsActionTypes.GET_CONTACT,
    payload: { id },
});

export const addContact = (contact: any): ContactsAction => ({
    type: ContactsActionTypes.ADD_CONTACT,
    payload: contact
})
export const updateContact = (contact: any): ContactsAction => ({
    type: ContactsActionTypes.UPDATE_CONTACT,
    payload: contact
})
export const deleteContact = (id: string): ContactsAction => ({
    type: ContactsActionTypes.DELETE_CONTACT,
    payload: { id }
})

export const listContacts = (params: any): ContactsAction => ({
    type: ContactsActionTypes.LIST_CONTACTS,
    payload: params,
});


export const resetContacts = (): ContactsAction => ({
    type: ContactsActionTypes.RESET,
    payload: {},
});

